module.exports = __webpack_public_path__ + "img/c-clients-6.jpg";